import { Feedback } from "../feedback/feedback";

/**
 * FOX-3618 — terminal page shown when the identity-side redirect-loop breaker
 * trips (see app/utils/redirect-loop-guard.ts). We reached here because identity
 * reflected this browser back to a downstream host too many times in a short
 * window and that host kept bouncing the (authenticated) user straight back —
 * almost always because the user has a valid session but no access to the space
 * / page they were sent to. Rendering a terminal page here breaks the loop by
 * construction (a 200 render, not another 302).
 *
 * Copy is intentionally plain strings, not `<Trans>`/`t` macros: web.identity
 * ships committed compiled Lingui catalogs and does NOT re-extract at build
 * time, so a brand-new message id would render as its raw hash in staging/prod.
 * These strings render verbatim with zero hash risk. `Feedback`'s own default
 * CTA labels ("Back to home" / "Contact support") reuse existing catalog ids.
 * Follow-up: convert to `<Trans>` and regenerate catalogs (matches the Stage 2
 * web.space terminal-page follow-up).
 */
export function RedirectLoopBlocked() {
  return (
    <Feedback
      code={400}
      /* eslint-disable lingui/no-unlocalized-strings -- see file header: plain strings avoid the compiled-catalog raw-hash trap */
      title="We couldn't complete sign-in"
      subtitle={
        "You're signed in, but we couldn't finish sending you to that page — " +
        "you may not have access to it. Contact your administrator if you think " +
        "this is a mistake, or head back home to continue."
      }
      /* eslint-enable lingui/no-unlocalized-strings */
    />
  );
}
